const XCENCORE_MOTION_SELECTOR = [
  '.xc-gift__path',
  '.xc-gift__products article',
  '.xc-gift__service-grid article',
  '.xc-gift__promise article',
  '.pawrielle-accents__grid article',
  '.pawrielle-shipping__timeline article',
  '.pawrielle-shipping__faq details',
].join(',');

function setupXCENCOREMotion() {
  const main = document.querySelector('main[data-template="index"]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  if (!main || reduceMotion.matches || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('xc-motion-enabled');

  const hero = main.querySelector('.xc-hero');
  const heroItems = hero?.querySelectorAll(
    '.xc-hero__eyebrow, .xc-hero h1, .xc-hero__lede, .xc-hero__actions'
  );

  heroItems?.forEach((item, index) => {
    item.classList.add('xc-motion-hero-item');
    item.style.setProperty('--xc-motion-order', index);
  });

  if (hero) {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => hero.classList.add('xc-motion-hero-ready'));
    });
  }

  const revealObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('xc-is-visible');
        revealObserver.unobserve(entry.target);
      });
    },
    // A tall mobile homepage section can never occupy 12% of the viewport at
    // once. Keep the reveal trigger low so long sections do not remain hidden.
    { threshold: 0.01, rootMargin: '0px 0px -8% 0px' }
  );

  const prepareSection = (section, sectionIndex) => {
    if (!(section instanceof HTMLElement) || section.querySelector('.xc-hero')) return;
    if (section.classList.contains('xc-motion-section')) return;

    section.classList.add('xc-motion-section');
    section.style.setProperty('--xc-section-order', Math.min(sectionIndex, 3));

    section.querySelectorAll(XCENCORE_MOTION_SELECTOR).forEach((item, itemIndex) => {
      item.classList.add('xc-motion-item');
      item.style.setProperty('--xc-motion-order', itemIndex % 4);
    });

    revealObserver.observe(section);
  };

  Array.from(main.children).forEach(prepareSection);

  let framePending = false;
  const updateHeroParallax = () => {
    framePending = false;
    if (!hero) return;

    const rect = hero.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;

    const progress = Math.min(1, Math.max(0, -rect.top / Math.max(rect.height, 1)));
    hero.style.setProperty('--xc-hero-shift', `${(progress * 28).toFixed(2)}px`);
  };

  const requestHeroParallax = () => {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(updateHeroParallax);
  };

  updateHeroParallax();
  window.addEventListener('scroll', requestHeroParallax, { passive: true });

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target?.closest?.('.shopify-section') || event.target;
    prepareSection(section, 0);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupXCENCOREMotion, { once: true });
} else {
  setupXCENCOREMotion();
}
